<template>
	<div class="indexContainer">
		<Header></Header>
		<div class="bannerWrapper">
			<img src="../../assets/img/tecSupport/banner1.jpg" alt="" class="bannerImg"  style="width: 100%;"/>
		</div>
		<div class="indexContentContainer">
			<div class="tab-list" style="border-bottom: 1px solid #E7E7E7;">
				<ul class="container" style="display: flex; margin: 10px auto; margin-bottom: 0;">
					<li class="active">
						<span class="tab-title">常见问题</span>
					</li>
					<li>
						<!--<span class="tab-title">接口对接</span>-->
					</li>
					<li>
						<!--<span class="tab-title">接口标准</span>-->
					</li>
					<li>
						<!--<span class="tab-title">与第三方对接</span>-->
					</li>
					<li>
						<!--<span class="tab-title">用户实施</span>-->
					</li>
				</ul>
			</div>
			<div class="tabContent">
				<div class="question-box container">
					<ul class="question2">
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">手机APP怎么注册？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">
									（1）配送员用户注册：输入手机号（SO56APP的用户名只能为手机号码）和密码后，点击获取验证码，查看刚刚输入的手机号收到的SO56验证码短信，填写验证码并同意用户协议，点击注册提交信息，完成注册。<br> （2）企业用户注册：企业用户不能自己注册，只能由管理员后台分配用户名和密码。
								</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">注册用户如何成为认证配送员并接单</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">点击首页面的“运力合作”按钮，进入到运力合作页面，选择加入方式（如选择“全职配送员招募”按钮），进入到个人信息页面，填写好个人的真实信息并提交，待后台工作人员审核通过后，您就成为认证配送员，后台调度就能分配给您运单了。 </div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">PC端怎么注册？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">PC端账户由系统管理员统一分配，请联系400-9696-299注册用户并分配账号。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">配送员怎么接单？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">点击菜单里的运单选项，进入运单页面，首次进入会刷新界面，如果有未确认运单，会显示未确认的运单，点击下方的接单按钮，就实现接单了，接单完成，运单进入未开始界面，请左滑查看。目前APP不支持配送员拒接运单，如果有问题请联系客服400-9696-299。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">什么是常规运单？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">目的地固定的运单。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">常规运单到达配货地怎么签收？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">达到配货地卸完货物，对配货单和货物进行拍照上传后台。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">常规运单操作步骤？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">（1）在未确认栏，点击确认接单<br> （2）确认接单后的运单会出现在未开始栏，点击详情进入前往发货地页面，配送员前往发货地时，点击前往发货地按钮，运单进入进行中状态，配送员运单状态变为前往发货地状态
									<br> （3）配送员到达发货地时，点击到达发货地按钮，配送员运单状态变为到达发货地状态
									<br> （4）配送员完成装货后，对配货单以及车辆拍照后，点击完成装货按钮，配送员运单状态变为完成装货状态
									<br> （5）配送员到达收货地，点击到达收货地按钮，配送员状态变为到达收货地状态
									<br> （6）配送员卸完货位，点击卸货完成按钮，配送员运单状态变为完成卸货状态
									<br> （7）如果所有配送点配送完毕，即配送员运单状态固定为完成卸货状态，如果还有配送点没有配送，配送员状态会回到前往发货地状态，以此循环操作，直到全部配货点配送完成，运单状态变为已完成状态。
								</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">什么是非常规运单？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">目的地不固定的运单。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">非常规运单怎么操作？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">（1）配送员在未确认栏里点击接单按钮完成接单，更新运单状态为未开始状态<br> （2）配送员在未开始栏点击详情接入非常规运单的开始界面，配送员对运单和车辆拍照后点击开始按钮，运单进入进行中状态，配送员运单状态变为进行中状态
									<br> （3）配送员在输入点位界面中，对配货单拍照，以及输入要进行配货的点位个数，点击确认提交信息，后台记录配送员提交的配货单以及配货点位数
									<br> （4）配送员进入打卡界面，在配送员每到达一个配货点位时，需要点击一下屏幕上的确认到达配货点按钮，完成配货点的完成记录，方便后台查看配货位置
									<br> （5）完成全部配货点位时，返回到非常规运单结束页面，配送员对完成后的运单拍照以及车辆拍照，点击结束按钮完成非常规运单，配送员运单状态变为已完成状态，运单状态变为已完成状态。
								</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">非常规运单到达配送点怎么签收？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">达到配送点，卸完货物，点击屏幕上的到达配送点，完成一个配送点时点一次。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">全职配送员的工资怎么组成？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">基本工资+节假日补贴+单车费用提成。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">不能刷新页面？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">检查是否已经连接上网络，如果未连接，请连接网络后再刷新页面；如果已经连接网络，请到网络好的地方进行刷新页面。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">拍照传不上来？</div>
							</div>
							<div class="am-cf question3">
								<div style="margin-left: 25px;" class="question4 question5">（1）网络不好导致照片传不上来，请到网络好的地方进行照片的传输。<br>（2）单张照片过大即超过2M导致照片传不上来，选择单张小于2M的照片传输。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">上传头像怎么切割？</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">尽量剪切为正方形图片上传。</div>
							</div>
						</li>
						<li class="am-cf">
							<div class="am-cf question3">
								<div><img src="../../assets/img/images/icon39.png"></div>
								<div class="question4">其他问题</div>
							</div>
							<div class="am-cf question3">
								<div class="question4 question5">如果遇到其他问题，请拨打客服电话：400-9696-299。</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
    <!-- <Suggest></Suggest> -->
		<Footer></footer>
	</div>
</template>

<script>
	import Header from '../../components/common/header.vue';
	import Footer from '../../components/common/footer.vue'
  // import Suggest from '../../components/common/suggest.vue'
	export default {
		components: {
			Header,
			Footer,
      // Suggest
		}
	}
</script>

<style scoped>
	@import '../../assets/css/animate.min.css'; 
	@import '../../assets/css/bootstrap.min.css' 
	
	.bannerWrapper .bannerImg {
		width: 100%;
	}
	.tab-list ul li{
		flex: 1;
		text-align: center;
	}
	.tab-list ul li span{
		display: inline-block;
		padding: 15px 10px;
		border-bottom: 2px solid transparent;
		color: #979EA7;
		font-size: 2.2rem;
		cursor: pointer;
	}
	.tab-list ul li.active span, .tab-list ul li:hover span{
		border-color: #FF6600;
		color: #FF6600;
		font-weight: bold;
	}
	.question2 li {
		margin-top: 1vw;
		border-bottom: 2px solid #f3f3f3;
		color: #aeb3ba;
	}
	
	.question3 {
		margin-bottom: 1vw;
		font-size: 1.6rem;
		color: #061F3E;
		font-weight: bold;
	}
	
	.question3 div {
		float: left;
	}
	
	.question4 {
		margin-left: 1%;
	}
	.question4:not(.question5){
		height: 30px;
		line-height: 30px;
	}
	.question5 {
		color: #979EA7;
		font-size: 1.4rem;
		font-weight: normal;
		line-height: 23px;
	}
	
	.am-cf:before,
	.am-cf:after {
		content: " ";
		display: table;
	}
	
	.am-cf:after {
		clear: both;
	}
</style>


// WEBPACK FOOTER //
// src/components/pages/technical_support.vue